import { createTranslations } from '@momentum/i18n';
import { tasksEnTranslations } from './tasks.en';

export const tasksHeTranslations = createTranslations(tasksEnTranslations, {
  // Page
  pageTitle: 'משימות',
  pageDescription: 'נהל ועקוב אחר כל המשימות בפרויקטים שלך',

  // Table Headers
  title: 'כותרת',
  creator: 'יוצר',
  status: 'סטטוס',
  assignees: 'נמענים',
  startDate: 'תאריך התחלה',
  dueDate: 'תאריך יעד',
  goal: 'יעד',
  actions: 'פעולות',

  // Status Values
  completed: 'הושלם',
  inProgress: 'בתהליך',
  notStarted: 'לא התחיל',
  blocked: 'חסום',

  // Messages
  loadingTasks: 'טוען משימות...',
  errorLoadingTasks: (error: string) => `שגיאה בטעינת משימות: ${error}`,
  noTasksFound: 'לא נמצאו משימות',
  showingTasks: (count: number) =>
    count === 1 ? 'מציג משימה אחת' : `מציג ${count} משימות`,

  // Actions
  createTask: 'צור משימה',
  editTask: 'ערוך משימה',
  deleteTask: 'מחק משימה',
  viewDetails: 'צפה בפרטים',
});
